module.exports = __webpack_public_path__ + "img/Wienerberger.2053819a.jpg";